import {
  FACTURATION,
  MONTANT_FIXE,
} from '@/configuration/presse/produitSalon/produitSalonConfiguration';

export default function genererReglesAchat() {
  return {
    dateDebut: null,
    dateFin: null,
    pourcentageReversement: null,
    montantFixeReversement: null,
    montantReversementGaranti: null,
    cAGaranti: null,
    typeCalcul: FACTURATION,
    typeMontant: MONTANT_FIXE,
    regimeTvaId: null,
    produitId: null,
    tranchesAchat: [],
    selected: false,
    ProduitAchatCommissionId: null,
  };
}
